import { StringSchema } from 'yup';

import { onlyNumbers } from '@/utils/format';
import { cellphoneValidate } from '@/utils/validations/cellphone';
import { telephoneValidate } from '@/utils/validations/telephone';

export function telephoneOrCellphone(this: StringSchema, message = 'Insira um telefone ou celular válido') {
  return this.test('telephoneOrcellPhone', message, (value = '') => {
    const validate = value.length <= 10 ? telephoneValidate : cellphoneValidate;

    if (!value.length) return true;

    return validate(onlyNumbers(value));
  });
}
